import React from "react";
import Button from "./atoms/Button";
import CityCallButton from "./city-call-button";
import cityPageContent from "../data/city-page-content";

const services = [
  {
    title: "Tile Roofing Installation & Repair",
    description:
      "We deliver expert tile roof installation and repairs. Contact us today for a free, no-obligation estimate.",
  },
  {
    title: "Roof Repair and Restoration",
    description:
      "Restore your roof to its original condition with our repair and restoration services. We address issues early, offering lasting solutions that extend the life of your roof.",
  },
  {
    title: "Owens Corning Shingle Roofing Systems",
    description:
      "Premium Owens Corning shingle roofing installations. Featuring durable, long-lasting materials backed by industry-leading warranties for maximum protection and peace of mind.",
  },
  {
    title: "Metal Alliance Mechanically Seamed Metal Roofs",
    description:
      "Durable, high-efficiency metal roofs with mechanical seaming, built to handle the toughest weather. Perfect for both residential and commercial properties.",
  },
  {
    title: "Custom Roofing Projects",
    description:
      "Custom roofing solutions for unique architectural designs. Our team brings creative expertise to every project, ensuring your vision becomes a reality with precision craftsmanship.",
  },
  {
    title: "Advanced Flat Roofing Systems",
    description:
      "Specialized flat roofing systems designed for commercial properties. Using advanced materials and techniques, we ensure watertight, lasting solutions.",
  },
];

const padNumber = (n) => String(n).padStart(2, "0");

const RoofingServicesGrid = ({ city, service }) => {
  const location = city ? city : "Your Area";
  // Pages with their own card set override the shared list.
  const { includedHeading, services: cityServices } = cityPageContent.forPage(city, service);
  const cards = cityServices && cityServices.length ? cityServices : services;

  return (
    <section className="py-12">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
        <div className="bg-neutral-800 rounded-2xl px-6 py-12 md:px-12 md:py-16">
          <h2 className="text-center text-2xl md:text-3xl font-display font-extrabold text-white mb-10">
            {includedHeading || `Roach Home Roofing Services in ${location}`}
          </h2>
          <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-6">
            {cards.map(({ title, description }, i) => (
              <div
                key={i}
                className="bg-white rounded-xl p-6 md:p-8 shadow-sm flex flex-col"
              >
                <div className="inline-flex items-center justify-center w-10 h-10 rounded-full border border-neutral-300 text-neutral-700 text-xs font-semibold mb-5">
                  {padNumber(i + 1)}
                </div>
                <h3 className="font-display font-bold text-lg text-neutral-900 mb-4">
                  {title}
                </h3>
                <p className="text-neutral-600 leading-relaxed">
                  {description}
                </p>
              </div>
            ))}
          </div>
          <div className="flex flex-wrap items-center justify-center gap-4 mt-10">
            <Button color="red" size="big" to="/contact/">
              Schedule a Free Consultation
            </Button>
            <CityCallButton city={city} onDark />
          </div>
        </div>
      </div>
    </section>
  );
};

export default RoofingServicesGrid;
